<template>
    <div class="mt-0 pt-0">
        <b-navbar type="light" variant="light" class="pb-0 pr-0" toggleable="lg" :sticky="true">
                <div class="row col-12 pr-0">
                    <div class="row col-12 pb-0 pr-0">
                        <h4 class="mb-0">{{report.title}}</h4>
                        <b-navbar-nav class="ml-sm-1 ml-md-auto tools">
                            <b-nav-item @click="reload()" v-b-tooltip.hover title="Get fresh data">
                                <font-awesome-icon icon="sync-alt"/>
                                Reload
                            </b-nav-item>
                        </b-navbar-nav>
                    </div>
                    <div v-if="parameters.length > 0" class="row col-12 parameters pr-0">
                        <b-navbar-toggle target="show_nav"/>
                        <b-collapse is-nav id="show_nav" class="pr-0">
                            <parameters-show></parameters-show>
                        </b-collapse>
                    </div>
                </div>
        </b-navbar>
        <div class="col-md-10 col-sm-10 mx-auto mt-3">
            <grid-layout :layout.sync="elements" :cols="{ lg: 40, md: 34, sm: 10, xs: 8, xxs: 4 }"
                :col-num="30" :row-height="8" :is-draggable="false" :is-resizable="false"
                :is-mirrored="false" :vertical-compact="true" :margin="[10, 10]"
                :use-css-transforms="true" :responsive="true">
                <grid-item v-for="element in elements" :key="element.i" class="border"
                    :autoSize="true" :x="element.x" :y="element.y" :w="element.w" :h="element.h" :i="element.i"
                    :verticalCompact="false"
                    :style="{overflow: element.type == 'chart'? 'auto': 'none'}">
                    <component :is="`${element.type}-component`" :id="element.i" :report_id="report_id"
                        :data="element.data" :show="true" :exportOption="true">
                    </component>
                </grid-item>
            </grid-layout>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { GridLayout, GridItem } from 'vue-grid-layout';
    import TextComponent from './TextShow.vue';
    import ChartComponent from '../../components/Chart.vue';
    import ParametersComponent from './Parameters.vue';
    import ParametersShow from '../../components/ParametersShow.vue';

    export default {
        props: ['report_id'],
        data() {
            return {

            }
        },
        components: {
            GridLayout,
            GridItem,
            TextComponent,
            ChartComponent,
            ParametersComponent,
            ParametersShow
        },
        computed: {
            ...mapState('reports', {
                status: 'status',
                organizationOwner: 'organizationOwner',
                report: 'report',
                parameters: 'parameters',
            }),
            elements: {
                get() {
                    return this.$store.state.reports.elements;
                },
                set(value) {
                    this.$store.commit('reports/SET_REPORT_ELEMENTS', value);
                }
            }
        },
        beforeCreate() {
            $('html').removeClass('login');
        },
        methods: {
            reload() {
                this.$store.commit('reports/SET_PARAMETERS');
            },
        },

    }
</script>

<style scoped>
    .parameters {
        margin-top: -5px
    }
    .tools {
        margin-top: -3px
    }
    .bg-light {
        background-color: #eef0f1 !important;
    }
    .vue-grid-item.no-touch {
        touch-action: auto;
    }
</style>
